<template>
  <v-container fill-height fluid class="hero-image">
    <v-row align="center" justify="center">
      <v-col cols="9" align="center">
        <v-form id="loginForm" lazy-validation
          @keyup.native.enter="signIn"
          @submit.prevent="signIn"
          ref="form"
          v-model="valid"
        >
          <v-text-field 
            label="Correo electrónico" 
            prepend-icon="mdi-account-circle"
            v-model="email"
            :rules="emailRules"
          />
          <v-text-field
            :type="showPassword ? 'text' : 'password'" 
            label="Contraseña"
            prepend-icon="mdi-lock"
            v-model="password"
            :rules="passwordRules"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
        </v-form>
        <v-row align="center" justify="center">
          <v-col cols="9" align="center">
            <v-btn tile color="success" @click="signIn" form="loginForm"
              :disabled="!valid" :loading="loading">Ingresar</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from '@/store'
import * as firebase from "firebase"

export default {
  data() {
    return {
      valid: false,
      loading: false,
      email: "",
      emailRules: [
        v => !!v || 'Ingrese su correo electrónico',
        v => /.+@.+\..+/.test(v) || 'Ingrese una direccion válida',
      ],
      password: "",
      passwordRules: [
        v => !!v || 'Ingrese su contraseña',
        v => v.length > 3 || 'La contraseña es muy corta',
      ],
      error: null,
      showPassword: false
    };
  },
  methods: {
    validate () {
      return this.$refs.form.validate()
    },
    signIn() {
      if (this.validate()) {
        this.loading = true
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.$router.replace({ name: "Home" })
            this.loading = false
          })
          .catch(err => {
            store.dispatch("setError", err.message)
            this.loading = false
          });
      }
    }
  },
  async created() {
    this.loading = true
    if (await firebase.getCurrentUser()) {
      this.$router.push('/home')
    }
    this.loading = false
  }
};
</script>
